import * as React from "react";
export default function useEventCallback(fn) {
    var ref = React.useRef(fn);
    React.useLayoutEffect(function () {
        ref.current = fn;
    });
    return React.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return ref.current.apply(ref, args);
    }, []);
}
